module.exports = __webpack_public_path__ + "img/forms-template.672f9e07.png";